import { FC } from 'react';

import { ESHOP_TEST_ID } from '@telialt/core-eshop/src/test/test-ids';

import { MarketingTagImg } from './MarketingTag.styles';

type Props = {
    marketingTag: {
        url: string;
        altText?: string;
    };
};

export const MarketingTag: FC<Props> = ({ marketingTag }) => {
    if (!marketingTag || !marketingTag?.url) {
        return null;
    }

    return (
        <MarketingTagImg
            data-test={ESHOP_TEST_ID.MARKETING_TAG}
            src={marketingTag?.url}
            alt={marketingTag?.altText || ' '}
        />
    );
};
